module.exports = __webpack_public_path__ + "img/30.f40a0085.png";